import React from 'react'
import cx from 'classnames'
import Video from '/js/views/shared/components/contentParticles/video'
import Image from '/js/views/shared/components/contentParticles/image'

class HighlightStat extends React.Component {
  renderMainText() {
    const { content, theme } = this.props

    if (!content.texts.mainText) {
      return null
    }

    return (
      <span
        data-label="highlight-stat-main-text"
        className={`uppercase font-condensed ${theme.textColor}`}
      >
        {content.texts.mainText}
      </span>
    )
  }

  renderAdditionalText() {
    const { content, theme } = this.props

    if (!content.texts.additionalText) {
      return null
    }

    return (
      <span
        data-label="highlight-stat-additional-text"
        className="uppercase font-condensed text-granite-gray"
        dangerouslySetInnerHTML={{ __html: content.texts.additionalText }}
      />
    )
  }

  renderMainTextSubscript() {
    const { content, theme } = this.props

    if (!content.texts.mainTextSubscript) {
      return null
    }

    return (
      <span
        data-label="highlight-stat-subscript"
        className={`uppercase font-condensed ${theme.textColor}`}
      >
        {content.texts.mainTextSubscript}
      </span>
    )
  }

  render() {
    const { content, theme } = this.props
    const hasMedia = content.youtubeID || content.images ? true : false

    return (
      <div
        className={cx('text-center w-full flex items-center', {
          'flex-col justify-start': !content.images,
          'justify-center': content.images
        })}
        data-label="highlight-stat"
      >
        {content.texts.leadin && (
          <span
            className={`block uppercase font-condensed text-16 mb-20 ${theme.textColor}`}
          >
            {content.texts.leadin}
          </span>
        )}

        {content.images && (
          <div className={cx("mr-10", {
            "w-90": !content.images.altWidth,
            "w-65": content.images.altWidth
          })}>
            <Image images={content.images} />
          </div>
        )}

        {content.youtubeID && (
          <span className="mb-15 w-full">
            <Video
              content={content}
              offsetButton={true}
              theme={theme}
              highlight={true}
            />
          </span>
        )}

        <p className={cx({
          "w-full": !content.images
        })}>
          <span className="flex items-end justify-center mb-20 leading-sixth">
            <span className={`text-48 ${hasMedia ? 'xl:text-96' : 'xl:text-96'}`}>
              {this.renderMainText()}
            </span>

            <span
              className={`text-24 leading-quarter ${
                hasMedia ? 'xl:text-48' : 'xl:text-48'
              }`}
            >
              {this.renderMainTextSubscript()}
            </span>
          </span>
          <span className={hasMedia ? 'text-18' : 'text-18'}>
            {this.renderAdditionalText()}
          </span>

          {content.texts.subtext && (
            <span className={`block mx-auto pt-5 text-granite-gray text-14`}>
              {content.texts.subtext}
            </span>
          )}
        </p>
      </div>
    )
  }
}

export default HighlightStat
